import logger from 'utils/logger.util';

const L = logger('apDepositUpdaterFor'); // eslint-disable-line no-unused-vars

const apDepositUpdaterFor = (result) => {
  const newDepositJson = result?.json ?? {};

  return (data) => {
    if (!data) {
      L.debug('()', 'Bad initial data:', data, 'aborting merge...');
      return data;
    }

    const originalAppointmentJson = data.json;

    return {
      ...data,
      json: {
        ...(originalAppointmentJson ?? void 1),
        deposit: {
          ...(originalAppointmentJson?.deposit ?? void 1),
          status: newDepositJson?.depositType ?? originalAppointmentJson?.deposit?.status,
          source: newDepositJson?.source ?? originalAppointmentJson?.deposit?.source,
          amount: newDepositJson?.amount ?? originalAppointmentJson?.deposit?.amount,
        },
      },
    };
  };
};

export default apDepositUpdaterFor;
